import styled from "styled-components";
import Button from "../Button/index.js";

const size = {
  mobile: "768px",
};
const device = {
  mobile: `(max-width: ${size.mobile})`,
};

export const ModalBackground = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.35);
  position: absolute;
  top: 0;
  @media ${device.mobile} {
    visibility: hidden;
  }
`;

export const ModalWindow = styled.div`
  width: 40vw;
  background-color: white;
  position: absolute;
  top: calc(50% - 15vh);
  left: calc(50% - 20vw);
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.34);
  @media ${device.mobile} {
    width: 100vw;
    top: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    z-index: 999;
  }
`;

export const ModalHeader = styled.div`
  /* flex: 1 0 20%; */
  flex-grow: 1;
  flex-shrink: 0;
  padding: 0.5rem 0rem 0.5rem 1rem;
  display: flex;
  @media ${device.mobile} {
    flex-grow: 0;
    border-bottom: 1px solid #979797;
  }
`;

export const ModalTitle = styled.div`
  flex: 1 1 90%;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 0.5rem 0;
`;
export const ModalCloseIcon = styled.div`
  flex: 0 0 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-10px, -10px);
`;
export const CloseIcon = styled.div`
  height: 2rem;
  width: 2rem;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: rotate(-45deg);
  cursor: pointer;
`;

export const ModalBody = styled.div`
  /* flex: 2 0 60%; */
  flex-grow: 2;
  flex-shrink: 0;
  font-size: 1rem;
  padding: 0.5rem 1rem 2rem 1rem;
  @media ${device.mobile} {
    flex: 0;
    padding: 1rem;
  }
`;

export const ModalActions = styled.div`
  border-top: 1px solid #979797;
  /* flex: 1 0 20%; */
  flex-grow: 1;
  flex-shrink: 0;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: flex-end;
  @media ${device.mobile} {
    border-top: none;
    justify-content: flex-start;
    padding-left: 0.5rem;
  }
`;

export const CancelButton = styled(Button)`
  height: 2.5rem;
  width: 5rem;
`;
export const ContinueButton = styled(Button)`
  height: 2.5rem;
  width: 6rem;
`;
